module.exports = __webpack_public_path__ + "static/media/undo-disabled.97c75dee.svg";